import React, { useState } from "react";
import { getFullImagePath } from "./imageUtils";

type Props = {
  src: string | undefined;
  addBaseUrl?: boolean;
  alt: string;
  className?: string;
  style?: React.CSSProperties;
  onClick?: () => void;
};

const MyImage = ({ src, addBaseUrl = false, alt, className, onClick, style, ...rest }: Props) => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  const handleLoad = () => {
    setLoading(false);
  };

  const handleError = () => {
    setLoading(false);
    setError(true);
  };

  // Dynamically manage image path with base URL if required
  src = addBaseUrl ? getFullImagePath(src) : src;

  return (
    <img
      onClick={onClick}
      src={error ? "https://partsfinder.clpstudio.ro/images/no_image_placeholder.jpg" : src}
      alt={error ? "Error" : alt}
      className={className}
      style={style}
      onLoad={handleLoad}
      onError={handleError}
      {...rest}
    />
  );
};

export default MyImage;
